<template>
  <div>
    <el-row style="margin-bottom: 24px;border-bottom: 1px solid #ddd;">
      <el-col :span="16" style="vertical-align: middle;">
        <h1>登錄資料 - {{page_structure['name']}}</h1>
      </el-col>
      <el-col :span="8" style="text-align: right;vertical-align: middle;">
        <el-button icon="el-icon-edit" @click="handle_save_button_click">儲存變更</el-button>
      </el-col>
    </el-row>
    <el-row>
      <EditViewForm 
        :handle_dynamic_form_update="handle_dynamic_form_update"
        :handle_file_upload="handle_file_upload"
        :page_structure="page_structure"
        :preloaded_data="context"
        :mode="mode"
        :preloaded_data_update_flag="preloaded_data_update_flag"
        />
    </el-row>
    <LoadingBlock :active="loading"></LoadingBlock>
  </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'
import PageStructure from '@/views/backstage/structure/system_management_page/account_management_page/AccountEditPageStructure'
import EditViewForm from '@/components/backstage/EditViewForm/EditViewForm.vue'
import breadcrumbMixin from '@/mixins/breadcrumbMixin'

export default {
    mixins: [breadcrumbMixin],
    components: {
      LoadingBlock,
      EditViewForm,
    },
    data() {
      return {
        loading: false,//TODO: change this to true
        page_structure: [],
        context: {}, 
        resource_api: process.env.VUE_APP_API_BACKSTAGE_URL + '/account',
        resource_identifier: 'id',
        account_id: null,
        options: {},
        file_lists: {},
        file: {},
        preloaded_data_update_flag: 0
      }
    },
    computed: {
      mode () {
        return this.account_id? 'edit': 'add'
      }
    },
    created: async function () {
        console.log('AccountEditPage: route id:', this.$route.params.id)

        this.page_structure = PageStructure(this.$route.params.type)
        console.log('AccountEditPage: page structure:', this.page_structure)
        
        let temp = this.forge_context_container(this.page_structure)

        this.account_id = this.$route.params.id
        console.log('AccountEditPage: org id:', this.account_id)

        this.context = JSON.parse(JSON.stringify(temp))
        // #216 add pwd 給0 , edit 給 get 拿到的值
        this.context['password'] = 0
        console.log('AccountEditPage: context: ', this.context)

        await this.get_context()
        this.preloaded_data_update_flag += 1

        if (this.context && this.context['roles']) {
          this.permission_check({
            resource_info: { 
              name: this.page_name.PAGE_ACCOUNT_MANAGEMENT,
              context: {
                roles: this.context['roles'][0]['role_name']
              }
            },
            access: { name: this.permission.EDIT },
            reject: { action: this.permission.REJECT_REDIRECT, path: '/dashboard' }
          })
        }
        else {
          this.permission_check({
            resource_info: { 
              name: this.page_name.PAGE_ACCOUNT_MANAGEMENT,
              context: null
            },
            access: { name: this.permission.ADD },
            reject: { action: this.permission.REJECT_REDIRECT, path: '/dashboard' }
          })
        }
    },
    methods: {
      handle_save_button_click () {
        console.log('save button clicked')

        console.log('this.file_lists:', this.file_lists)

        let param = this.translate_to_form_data(this.page_structure, this.context)
        // #216 add pwd 給空 , edit 給 get 拿到的值
        param.append('password', this.context['password']);
        let self = this 
        
        let config = { headers:{'Content-Type':'multipart/form-data'} } 

        let action = 'add'
        if (this.account_id) {
          action = 'edit'
          param.append(this.resource_identifier, this.account_id);
        }
        this.loading = true
        axios.post(this.resource_api+'/'+action, param, config)
          .then (response => { 
            this.loading = false
            if (!response.data.success) {
              console.log('save/edit failed, msg='+response.data.message+', reponse=', response)
              this.notify_message(this.ERROR.LEVEL.ERROR, '新增/編輯失敗', response.data.message)
              return
            }

            console.log('save/edit succeed, response=', response)
            
            if (self.mode === 'add') {
                this.backstage_router_push({ path: `/system-management/account-management/view/${response.data.payload.id}` })
            }
            else {
                this.backstage_router_push({ path: `/system-management/account-management/view/${this.account_id}` })
            }

            return
          }) 
          .catch(({err}) => { 
            this.loading = false
            console.log('save/edit failed, err=', err)
            this.notify_message(this.ERROR.LEVEL.ERROR, '新增/編輯失敗', this.ERROR.MSG.general_err_msg)
          }) 
      },
      handle_delete_button_click () {
        console.log('delete button clicked')
      },
      async get_context () {
        if (!this.account_id) {
          return
        }

        let self = this

        this.loading = true
  
        await axios.get(this.resource_api+'/get', {params: {
            id: this.account_id
        }})
            .then((response) => {
            console.log('reponse: ', response.data.payload)
              if (response.data.success) {
                  let res = self.translate_to_edit_data(this.page_structure, response.data.payload, {mode: 'edit'})
                  for (let key in res) {
                      self.context[key] = res[key]
                  }
                  this.preloaded_data_update_flag += 1
                  this.update_breadcrumbs_title(this.context['username'])
              }
              else {
                this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得資料', response.data.message)
              }
            })
            .catch(err => {
                console.log(err)
                this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得資料', this.ERROR.MSG.general_err_msg)
            })


        this.loading = false
      },
      handle_file_upload (file_list_name, file) {
        console.log('handle file upload: file=',file_list_name, file)
        this.file_lists[file_list_name] = file
      },
      handle_dynamic_form_update (key, form_value) {
        console.log('AccountEditPage: handle_dynamic_form_update:' + key + ', value:', form_value)

        this.$set(this.context, key, form_value)
      }
    }
  };
</script>

<style>
</style>
